import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useCompanyStore } from '@/stores/company';
import { useGoogleReserveStore } from '@/stores/google-reserve';
import { useTreatwellStore } from '@/stores/treatwell';
import { useUserStore } from '@/stores/user';
import unleash from '@/unleash';

const useOnline = () => {
  const { showTreatwell, showTWOnboardingNotification } = storeToRefs(
    useTreatwellStore(),
  );
  const { hasFeatureFlag } = useUserStore();
  const { companySettings } = storeToRefs(useCompanyStore());
  const { showIntegration } = storeToRefs(useGoogleReserveStore());

  const hideOnlineRoutes = computed(
    () =>
      !unleash.isEnabled('WebsiteService') &&
      !showTreatwell.value &&
      !showIntegration.value &&
      !hasFeatureFlag('module-appointments'),
  );

  const showOnlineRoutesNotification = computed(() => {
    return (
      !companySettings.value?.onlineRoutes?.lastVisitedAt ||
      (showTreatwell.value && showTWOnboardingNotification.value)
    );
  });

  return {
    hideOnlineRoutes,
    showOnlineRoutesNotification,
  };
};

export default useOnline;
